/* eslint react/destructuring-assignment: 0 */
import React, { useEffect, useRef } from "react";

import { scrollIntoViewWithObserver } from "utils";

import { NavigationSplitViewTileProps } from "models";

import { Flex, Icon, Typography } from "components";

export const NavigationSplitViewTile = ({
  tile,
  selectedGroupIndex,
  selectedSubGroupIndex,
  selectedTileIndex,
  groupIndex,
  subGroupIndex,
  tileIndex,
  onTileClicked,
  dataTestId,
}: NavigationSplitViewTileProps) => {
  const tileRef = useRef<HTMLDivElement | null>(null);

  const isSameGroup = selectedGroupIndex === groupIndex;
  const isSameSubGroup = selectedSubGroupIndex === subGroupIndex;
  const isSameTile = selectedTileIndex === tileIndex;
  const isSelected = isSameGroup && isSameSubGroup && isSameTile;

  useEffect(() => {
    if (isSelected) scrollIntoViewWithObserver(tileRef);
  }, [isSelected]);

  return tile.show ? (
    <Flex
      ref={tileRef}
      className={`navigation-split-view-tile ${isSelected && "selected"}`}
      data-testid={`${dataTestId}-${tileIndex}`}
      align="center"
      justify="space-between"
      onClick={() => {
        scrollIntoViewWithObserver(tileRef);
        onTileClicked({ groupIndex: groupIndex, subGroupIndex: subGroupIndex, tileIndex: tileIndex });
      }}
    >
      <Typography variant="paragraph-m" data-testid={`${dataTestId}-${tileIndex}-title`} className="title">
        {tile.title}
      </Typography>
      <Flex className="value-icon-wrapper" gap="1rem" align="center" justify="space-between">
        <Typography variant="paragraph-m" data-testid={`${dataTestId}-${tileIndex}-value`} className="value">
          {tile.value}
        </Typography>
        <Icon dataTestId={`${dataTestId}-${tileIndex}-icon`} iconName="tabler/chevron-right" />
      </Flex>
    </Flex>
  ) : null;
};
